module.exports = __webpack_public_path__ + "img/product_default_img.930ade8d.svg";